import { Line } from '@ant-design/plots';

export default function PlotGraphics({ data, unit, multiple = false }) {
  const sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
  const config = {
    data: sortedData,
    padding: 'auto',
    xField: 'date',
    yField: 'value',
    xAxis: {
      tickCount: 5,
    },
    yAxis: {
      nice: true,
      label: {
        formatter: (text) => `${Number(text).toFixed(2)} ${unit ? unit : ''}`,
      },

    },
    slider: {
      start: 0,
    },
  };

  if (multiple) {
    config.colorField = 'steelblue';
    config.seriesField = 'division';
  }

  return <Line {...config} />;
}
